import React from "react";
import "./Recovery.css";
import image from "./Picture1.png";
const Recovery = () => {
  return (
    <>
      <section className="recovery-section">
        <div className="container">
          <div className="recovery-header">
            <img src={image} alt="" />
          </div>
          <div className="recovery-details">
            <p>
              For fund recovery from other platforms, kindly contact our
              customer service with the necessary information. We do not request
              passwords or OTPs for verification or recovery work. We appreciate
              your cooperation.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Recovery;
